module.exports = __webpack_public_path__ + "static/media/notes.5b3be28d.png";